import {IssueViewerContextProvider} from '@github-ui/issue-viewer/IssueViewerContextProvider'
import {VersionMismatchToastProvider} from '@github-ui/version-mismatch-detector/VersionMismatchToastProvider'
import type React from 'react'
import {Suspense} from 'react'

import {NavigationContextProvider} from './contexts/NavigationContext'
import {QueryContextProvider} from './contexts/QueryContext'

type AppProps = {children?: React.ReactNode}

export function App({children}: AppProps) {
  return (
    <VersionMismatchToastProvider appName="issues-react">
      <NavigationContextProvider>
        <QueryContextProvider>
          <IssueViewerContextProvider>
            <Suspense fallback={<span>Loading...</span>}>{children}</Suspense>
          </IssueViewerContextProvider>
        </QueryContextProvider>
      </NavigationContextProvider>
    </VersionMismatchToastProvider>
  )
}
